import React, { useEffect, useState } from "react";
import { Row, Col, Spinner, Container, Collapse } from "react-bootstrap";
import { NavLink, Outlet, Link } from "react-router-dom";
import { MdOutlineFlight } from "react-icons/md";

import { get_user } from "../../actions/myuser";
import { connect } from "react-redux";
import Navigation from "../Navigation";
import { FaUsers } from "react-icons/fa";
import { IoTicketOutline } from "react-icons/io5";
import { AiOutlineHome } from "react-icons/ai";
import { FaPlus, FaChevronUp, FaChevronDown } from "react-icons/fa6";
import { MdOutlineAirlines, MdOutlineAirplaneTicket } from "react-icons/md";
import SmallSideBar from "./SmallSideBar";
import { useNavigate } from "react-router-dom";
import { PiInvoiceFill } from "react-icons/pi";
import { LiaFileInvoiceSolid } from "react-icons/lia";

function SideBar({ user, get_user, isAuthenticated }) {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    get_user()
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return loading ? (
    <Container fluid>
      <Row>
        <Col className="loader d-flex justify-content-center align-items-center flex-column">
          <Spinner animation="border" variant="dark" />
        </Col>
      </Row>
    </Container>
  ) : (
    <Container fluid className="maincontainer">
      <Row>
        <Col lg={12} md={12} sm={12} className="nav-spacer">
          <Navigation />
        </Col>
        <Col
          lg={12}
          md={12}
          sm={12}
          className="mainarea">
          <Row className="h-100 g-0">
            <Col
              lg={2}
              md={2}
              sm={0}
              className="navigationcolumn d-none d-lg-block d-md-block">
              <nav style={{ paddingTop: "0.5rem" }}>
                <NavLink to="/ticketing/home" className="navanchor">
                  <AiOutlineHome className="icon" />
                  Dashboard
                </NavLink>
                <NavLink to={"/ticketing/tickets"} className="navanchor">
                  <IoTicketOutline className="icon" />
                  Tickets
                </NavLink>
                <NavLink
                  to="/ticketing/quotation"
                  className="navanchordrop navanchor">
                  <LiaFileInvoiceSolid className="icon" />
                  Quotations
                </NavLink>
                <NavLink to="/ticketing/airline" className="navanchor">
                  <MdOutlineAirlines className="icon" />
                  Airlines{" "}
                </NavLink>
                <NavLink to="/ticketing/flights" className="navanchor">
                  <MdOutlineFlight className="icon" />
                  Flights{" "}
                </NavLink>
                <NavLink to="/ticketing/clients" className="navanchor">
                  <FaUsers className="icon" />
                  Customers{" "}
                </NavLink>
              </nav>
              <div style={{ padding: "1rem 0.75rem" }}>
                <button
                  className={
                    window.location.pathname === "/ticketing/newbooking"
                      ? "btn btn-dark sidebarmainbutton"
                      : "btn btn-warning sidebarmainbutton"
                  }
                  onClick={() => {
                    navigate("/ticketing/newbooking");
                  }}>
                  <FaPlus
                    size={14}
                    color={
                      window.location.pathname === "/ticketing/newbooking"
                        ? "white"
                        : "black"
                    }
                    style={{ flexShrink: 0 }}
                  />
                  New Booking
                </button>
              </div>
            </Col>
            <Col lg={10} md={10} sm={12} className="contentarea">
              <Outlet />
            </Col>
          </Row>
        </Col>
      </Row>
      <SmallSideBar />
    </Container>
  );
}

const mapStateToProps = (state) => ({
  user: state.current_user.user,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { get_user })(SideBar);
